module.exports = __webpack_public_path__ + "static/media/14UNEP3.5615bea4.jpg";